<template>
  <div class="flex items-center justify-center h-[150px] w-full">
    <div class="w-8 h-8 border-4 border-gray-300 border-t-[#C6A798] rounded-full animate-spin mx-auto"></div>
  </div>
</template>

<script>
export default {
  name: 'LoaderVue',
  data(){
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
